import React from 'react';
export function RealitySection() {
  return <section className="py-16 md:py-20 bg-[#FFF8F0]" data-id="element-185">
      <div className="max-w-4xl mx-auto px-4" data-id="element-186">
        <div className="text-center mb-10 md:mb-12" data-id="element-187">
          <p className="text-xl text-gray-600 italic mb-4" data-id="element-188">
            Si estás buscando una forma REAL de generar ingresos, déjame hacerte
            una pregunta honesta…
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-189">
            ¿Te pasa que querés mejorar tu economía, pero no sabés por dónde
            empezar?
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#C084FC] to-[#F472B6] mx-auto mb-8 rounded-full" data-id="element-190"></div>
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-191">
            No porque no tengas capacidad. No porque no tengas ganas. <br data-id="element-192" />
            Sino porque el mundo laboral ya no funciona como antes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-10 md:mb-12" data-id="element-193">
          <div className="bg-white p-6 md:p-8 rounded-lg shadow-md border-l-4 border-[#C084FC]" data-id="element-194">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-195">
              El Problema:
            </h3>
            <ul className="space-y-3 text-gray-700" data-id="element-196">
              <li className="flex items-center" data-id="element-197">❌ Inversiones enormes</li>
              <li className="flex items-center" data-id="element-198">❌ Resultados inciertos</li>
              <li className="flex items-center" data-id="element-199">❌ El estrés sigue</li>
              <li className="flex items-center" data-id="element-200">❌ Las cuentas siguen</li>
              <li className="flex items-center" data-id="element-201">❌ La presión sigue</li>
            </ul>
          </div>
          <div className="bg-purple-50 p-6 md:p-8 rounded-lg shadow-md border-l-4 border-[#F472B6]" data-id="element-202">
            <h3 className="text-xl font-bold text-[#9333EA] mb-4" data-id="element-203">
              La realidad que casi nadie dice en voz alta:
            </h3>
            <p className="mb-4 font-medium text-gray-800" data-id="element-204">
              ⚠️ Hoy, una habilidad práctica vale más que un título colgado en
              la pared.
            </p>
            <p className="text-gray-600" data-id="element-205">
              Especialmente en estética. Porque la demanda existe. Los clientes
              existen. El dinero circula.
            </p>
          </div>
        </div>

        <div className="bg-[#3D1F2E] text-white p-6 md:p-8 rounded-lg shadow-md border-l-4 border-[#C084FC]" data-id="element-206">
          <h3 className="text-xl font-bold text-purple-300 mb-4" data-id="element-207">
            Si esto te resuena, este MegaPack es para vos:
          </h3>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-8" data-id="element-208">
            {['Querés generar ingresos extra', 'Querés trabajar por tu cuenta', 'No tenés experiencia previa', 'Querés empezar desde casa', 'Querés algo concreto y aplicable'].map((item, i) => <span key={i} className="bg-purple-50 text-purple-800 px-4 py-2 rounded-full font-medium text-sm border border-purple-100" data-id="element-209">
                ● {item}
              </span>)}
          </div>
          <p className="text-lg md:text-xl font-medium text-gray-200" data-id="element-210">
            Lo peor no es no saber. Es sentir que podrías estar haciendo algo…{' '}
            <br data-id="element-211" />
            <span className="text-purple-300 font-bold" data-id="element-212">
              pero seguir exactamente en el mismo lugar.
            </span>
          </p>
        </div>
      </div>
    </section>;
}